<template>
  <div class="left cadfm-flexitem-fixed">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="toggleLeftPanel" icon="hide" bold text="Hide" tooltip="Hide panel" :disabled="false" />



        </b-navbar-nav>
      </action-bar>
      <action-content>
        <div class="Tabs">
          <b-tabs card>

            <b-tab :title="lang.Content.tab_Info" :title-link-class="textColors" :title-item-class="textColors"
              active>
              
              <RequestInfoComponent :lang="lang.Content.RequestInfo"></RequestInfoComponent>
              
            </b-tab>


          </b-tabs>

        </div>
      </action-content>
    </action-panel>

  </div>
</template>


<script>

//import Right from '@/components/PartManager/Right/Right'
//import { mapGetters } from 'vuex'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import RequestInfoComponent from '@/components/shared/RequestInfoComponent'

//import RevisionDiagramComponent from '@/components/shared/RevisionDiagramComponent'

export default {
  name: 'Left',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,

    RequestInfoComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      name: "LeftContentRequestInfo",
      
    }
  },
  computed: {
    
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    
  },

  created() {

    

  },
  watch: {
    
  },
  updated() {
        

  },
  methods: {
    
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;

    }
  }
}
</script>


<style scoped>
.left{
  border-right: 1px solid #666;
  min-width: 400px;
}

.center-content{
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/RequestManager/Views/RequestDetails/Left/Left.vue